import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";

// Window start moves forward in steps so every node/edge on the canvas shares the same
// request params (RTK Query dedupes identical params) and long-running screens stay bounded.
const BUCKET_MS = 5 * 60 * 1000;
const currentBucket = () => Math.floor(Date.now() / BUCKET_MS);

/**
 * Date filters for live dashboard requests.
 * - value: last 12 hours, matching the 12-hour RUNNING/OFFLINE rule, for the latest reading.
 * - today: from local midnight, for live charts.
 * No upper bound is sent, so polling keeps picking up new readings.
 */
export const useLiveDataWindow = () => {
  const [bucket, setBucket] = useState(currentBucket);

  useEffect(() => {
    const id = setInterval(() => setBucket(currentBucket()), 60 * 1000);
    return () => clearInterval(id);
  }, []);

  return useMemo(() => {
    const now = dayjs(bucket * BUCKET_MS);
    return {
      value: { date_gte: now.subtract(12, "hour").toISOString() },
      today: { date_gte: now.startOf("day").toISOString() },
    };
  }, [bucket]);
};

export default useLiveDataWindow;
